module.exports = __webpack_public_path__ + "img/bingo_ball-11.bf1e2db9.png";